import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import "./App.css";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Projects from "./pages/Projects";
import Services from "./pages/Services";
import Navbar from "./components/Navbar";
import ShipManagement from "./pages/ShipManegment";
import TugBargeOperations from "./pages/TugBargeOperations";
import ShipDrydockServices from "./pages/ShipDrydockServices";
import CrewManningSupply from "./pages/CrewManningSupply";
import MarineTechnicalServices from "./pages/MarineTechnicalServices";
import VoyageRepairsAfloat from "./pages/VoyageRepairsAfloat";
import BunkerFreshWater from "./pages/BunkerFreshWater";
import SparePartsProcurement from "./pages/SparePartsProcurement";
import MaritimeSecurity from "./pages/MaritimeSecurity";
import ShipDesignNavalArchitecture from "./pages/ShipDesignNavalArchitecture";
import News from "./pages/News";
import Career from "./pages/Career";
import Apply from "./pages/Apply";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import NotFound from "./pages/NotFound";
import SEO from "./components/SEO";

export default function App() {
  const [, setCurrentPage] = useState("home");

  return (
    <Router>
      <SEO />
      <Navbar setPage={setCurrentPage} />
      <Routes>
        {/* Core Pages (supporting both lowercase canonical and uppercase aliases) */}
        <Route path="/" element={<Home />} />
        
        <Route path="/about" element={<About />} />
        <Route path="/About" element={<About />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/Contact" element={<Contact />} />

        <Route path="/projects" element={<Projects />} />
        <Route path="/Projects" element={<Projects />} />

        <Route path="/services" element={<Services />} />
        <Route path="/Services" element={<Services />} />

        <Route path="/news" element={<News />} />
        <Route path="/News" element={<News />} />

        <Route path="/career" element={<Career />} />
        <Route path="/Career" element={<Career />} />

        <Route path="/apply/:link" element={<Apply />} />
        <Route path="/apply" element={<Apply />} />

        {/* Services Routes */}
        <Route path="/services/ship-management" element={<ShipManagement />} />
        <Route path="/services/tug-barge-operations" element={<TugBargeOperations />} />
        <Route path="/services/drydock" element={<ShipDrydockServices />} />
        <Route path="/services/crew" element={<CrewManningSupply />} />
        
        {/* Both lowercase and uppercase for Marine Technical Services */}
        <Route path="/services/marine" element={<MarineTechnicalServices />} />
        <Route path="/services/Marine" element={<MarineTechnicalServices />} />

        <Route path="/services/voyage" element={<VoyageRepairsAfloat />} />
        <Route path="/services/bunker" element={<BunkerFreshWater />} />
        <Route path="/services/spare" element={<SparePartsProcurement />} />
        <Route path="/services/maritime-security" element={<MaritimeSecurity />} />
        <Route path="/services/ship-design-naval-architecture" element={<ShipDesignNavalArchitecture />} />

        {/* Legal Pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

        {/* 404 Fallback Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}